import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { i18n, namespaces } from '@sternum/web/services/i18n';

export const MinNameLength = 2;
export const MaxNameLength = 60;

export interface CreateDashboardNameValidationOptions {
  fieldName?: string;
  minNameLength?: number;
  maxNameLength?: number;
}

export function createDashboardNameValidation(
  t: TFunction = i18n.t,
  {
    fieldName = 'name',
    minNameLength = MinNameLength,
    maxNameLength = MaxNameLength,
  }: CreateDashboardNameValidationOptions = {},
) {
  return Yup.string()
    .trim()
    .required(
      t('required', {
        ns: namespaces.validation,
        field: fieldName,
      }),
    )
    .min(minNameLength, t('minLength', { ns: namespaces.validation, field: fieldName, limit: minNameLength }))
    .max(maxNameLength, t('maxLength', { ns: namespaces.validation, field: fieldName, limit: maxNameLength }));
}
